import {createAsyncThunk} from '@reduxjs/toolkit';
import {ACTION_TYPE} from '../actions-types';
import {AxiosResponse} from 'axios';
import {OrganizationReportsService} from '@/utils/services/organization-reports.service';
import {getErrorResponse} from '@/utils/helpers';
import {IRequestWithPagination} from '@/utils/types';
import {
	IGetUnpaidItemsResponse,
	IGetUnpaidTablesResponse,
	IGetParticipantsResponse,
	IGetMaxBidsResponse,
	IOrganizationFullReportColumns,
	IFinancialReportResponceWithPagination,
	IFinancialReportRequestWithPagination,
} from '@/utils/types/organization-reports.interface';

export const getReportUnpaidItems = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_UNPAID_ITEM,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IGetUnpaidItemsResponse> = await OrganizationReportsService.getUnpaidItems(
				reqBody
			);

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getReportUnpaidTables = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_UNPAID_TABLE,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IGetUnpaidTablesResponse> = await OrganizationReportsService.getUnpaidTables(
				reqBody
			);

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getReportParticipants = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_PARTICIPANTS,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IGetParticipantsResponse> = await OrganizationReportsService.getParticipants(
				reqBody
			);

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getReportMaxBids = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_MAX_BIDS,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IGetMaxBidsResponse> = await OrganizationReportsService.getMaxBids(reqBody);

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getReportedColumns = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_REPORTED_COLUMNS,
	async (_, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IOrganizationFullReportColumns[]> = await OrganizationReportsService.getReportColumns();

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);


export const getReportFullData = createAsyncThunk(
	ACTION_TYPE.REPORT_GET_ATTENDEE_FINANCIAL_REPORT,
	async (reqBody: IFinancialReportRequestWithPagination, {rejectWithValue}) => {
		try {
			const reportResponse: AxiosResponse<IFinancialReportResponceWithPagination> = await OrganizationReportsService.getAttendeeFinancialReport(reqBody);

			return reportResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
